import React from 'react'
import CustomTab, { Tabs } from '../../molecules/custom-tab/custom-tab'
import { useState } from 'react'
import { CanBeAnything } from '../../../types'
import { AssetMetaCard } from '../../atoms/asset-meta-card/asset-meta-card'
import './asset-info.scss'
import NoData from '../../molecules/no-data/no-data'
import { AssetUsageReporting } from '../asset-usage-reporting/asset-usage-reporting'

const tabOptions: Tabs[] = [
  { id: 1, title: 'Diagnostics' },
  { title: 'Usage Reporting', id: 2 },
]

interface AssetInfoProps {
  assetDetail: CanBeAnything
}
export const AssetInfo = ({ assetDetail }: AssetInfoProps) => {
  const [activeTab, setActiveTab] = useState(tabOptions[0]?.id)
  const cardDetails = []
  if (assetDetail) {
    if (assetDetail?.accountUsersSync) {
      cardDetails.push({
        label: 'accountUsersSync',
        ...assetDetail?.accountUsersSync,
      })
    }
    if (assetDetail?.historicalCampaignSync) {
      cardDetails.push({
        label: 'historicalCampaignSync',
        ...assetDetail?.historicalCampaignSync,
      })
    }
    if (assetDetail?.historicalAdsetsSync) {
      cardDetails.push({
        label: 'historicalAdsetsSync',
        ...assetDetail?.historicalAdsetsSync,
      })
    }
    if (assetDetail?.historicalAdsSync) {
      cardDetails.push({
        label: 'historicalAdsSync',
        ...assetDetail?.historicalAdsSync,
      })
    }
  }
  return (
    <div className="asset-info-container">
      <CustomTab tabs={tabOptions} activeTab={activeTab} handleTabChange={setActiveTab} />
      {activeTab === 1 ? (
        <div className="asset-info-diagnostics">
          {
            <>
              {assetDetail !== undefined && assetDetail?.adAccountId ? (
                cardDetails.map((detail, idx) => {
                  return <AssetMetaCard detail={detail} key={idx} />
                })
              ) : (
                <NoData message="" />
              )}
            </>
          }
        </div>
      ) : (
        <AssetUsageReporting accountId={assetDetail?.adAccountId} />
      )}
    </div>
  )
}
